import React from "react"
import { ExpenseCommonInputFieldsForm } from "~Components/forms/expenseForm/commonInputFields/ExpenseCommonInputFieldsForm"
import { OfferDocumentUploadForm } from "~Components/forms/expenseForm/commonInputFields/offerDocumentUpload.form"
import { OneTimeExpenseFields } from "~Components/forms/expenseForm/OneTimeExpenseFields"
import { useExpenseFormContext } from "~Components/modals/expenseCreateForm.context"
import { useAreCardsActivated } from "~Shared/hooks/corporate.hooks"
import { ResponsiveFormLayout } from "../../layout/ResponsiveFormLayout"
import { PaymentOptionSelector } from "./commonInputFields/paymentOptionSelector.form"

export const PurchaseRequestForm = () => {
    const [{ isNew, updateExpense, expenseForm }] = useExpenseFormContext()
    const cardsActive = useAreCardsActivated()

    return (
        <ResponsiveFormLayout
            leftSide={
                <>
                    {cardsActive && isNew && <PaymentOptionSelector />}
                    <OneTimeExpenseFields />
                    <ExpenseCommonInputFieldsForm />
                    <OfferDocumentUploadForm isNew={isNew} updateExpense={updateExpense} expenseForm={expenseForm} />
                </>
            }
        />
    )
}
